// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {text-decoration: none; color:black}
a:visited {color: black;text-decoration: none;}
a:hover {color: gray;text-decoration: none;}


.navbarContainer {
  margin: 0;
  padding: 5px;
  font-family: "Garamond", Georgia, 'Times New Roman', Times, serif;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: tomato;
  font-size: 40px;
  color: black
}

.container {
  padding-top: 20px;
  padding-bottom:20px;
  width: 200px;
  display: flex;
  justify-content: center;
}

.navbarButton img {
  max-width: 100%;
  max-height: 10vh;
}

.navbarButton {
  padding: 10px;
  flex: 1 0 auto;
  text-align: center;
  height: 100%;
  width: 20%
}

.navbarButton + .navbarButton {
  border-left: solid 3px black;
}`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAAA,GAAG,qBAAqB,EAAE,WAAW;AACrC,WAAW,YAAY,CAAC,qBAAqB,CAAC;AAC9C,SAAS,WAAW,CAAC,qBAAqB,CAAC;;;AAG3C;EACE,SAAS;EACT,YAAY;EACZ,iEAAiE;EACjE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["a {text-decoration: none; color:black}\na:visited {color: black;text-decoration: none;}\na:hover {color: gray;text-decoration: none;}\n\n\n.navbarContainer {\n  margin: 0;\n  padding: 5px;\n  font-family: \"Garamond\", Georgia, 'Times New Roman', Times, serif;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background-color: tomato;\n  font-size: 40px;\n  color: black\n}\n\n.container {\n  padding-top: 20px;\n  padding-bottom:20px;\n  width: 200px;\n  display: flex;\n  justify-content: center;\n}\n\n.navbarButton img {\n  max-width: 100%;\n  max-height: 10vh;\n}\n\n.navbarButton {\n  padding: 10px;\n  flex: 1 0 auto;\n  text-align: center;\n  height: 100%;\n  width: 20%\n}\n\n.navbarButton + .navbarButton {\n  border-left: solid 3px black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
